import { Pipe, PipeTransform } from '@angular/core';
import { VideoType } from "angular-engine/model/api.model";

@Pipe({name: 'runtime'})
export class RuntimePipe implements PipeTransform {
    transform(value: number): string {
        if(value < 60){
            return value + "s";
        }

        let result = "";
        let hours = -1;

        if(value >= 3600){
            hours = Math.floor(value / 3600);
            result = hours + ":";

            value = value % 3600;
        }

        let minutes = Math.floor(value / 60);
        if(minutes < 10 && hours > -1){
            result += "0";
        }
        result += minutes + ":";

        let seconds = value % 60;
        if(seconds < 10){
            result += "0";
        }
        result += seconds.toString();

        return result;
    }
}


@Pipe({name: 'videoType'})
export class VideoTypePipe implements PipeTransform {
    transform(value: VideoType): string {
        let pieces = value.url.split('.');
        let type = pieces[pieces.length - 1].toLowerCase();

        switch(type){
            case "mp4":
                return "video/mp4";
            case "m3u8":
                return "application/x-mpegURL";
            default:
                break;
        }

        return "video";
    }
}

@Pipe({name:'videoSources'})
export class VideoSourcesPipe implements PipeTransform {
    transform(item:any): any {
        if(item.obj_type == "Stream" && item.url)
        {
            return [{
                "type": "main",
                "url": item.url
            }];
        }
        return (item.video && item.video.meta || item).video_types || [];
    }
}


@Pipe({ name: 'video' })
export class VideoPipe implements PipeTransform {
    //TAKES THE META OBJECT AND SNIFFS OUT THE VIDEO OBJECT;
    transform(item: any): any {
        return item.hasOwnProperty("video") ? item.video.meta : item;
        // let videoObject;
        // if( item.obj_type = "Episode" && item.hasOwnProperty("video")){
        //     videoObject = item.video.meta;
        // }else if(item.obj_type = "Video" ){
        //     videoObject = item;
        // }
        // console.log(videoObject);
        // return videoObject;
    }
}

@Pipe({ name: 'hasVideo' })
export class HasVideoPipe implements PipeTransform {
    //TAKES THE META OBJECT AND SNIFFS OUT THE VIDEO OBJECT;
    transform(item: any): any {
        if (item.obj_type == "Episode") {
            return item.video;
        }
        return true
        // let videoObject;
        // if( item.obj_type = "Episode" && item.hasOwnProperty("video")){
        //     videoObject = item.video.meta;
        // }else if(item.obj_type = "Video" ){
        //     videoObject = item;
        // }
        // console.log(videoObject);
        // return videoObject;
    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-pipe/video.pipe.ts